import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    content: `Welcome to the CCF Co-Creation Farm platform ("the Platform" or "we").

1.1 By accessing or using the Platform (including the website, mobile applications, and related services), you ("the User" or "you") agree to be bound by these Terms of Service ("Terms"). If you do not agree to any part of these Terms, please do not use the Platform.

1.2 These Terms constitute a legally binding agreement between you and CCF Co-Creation Farm. Please read these Terms carefully in their entirety before using the Platform's services.

1.3 We reserve the right to modify these Terms at any time. Modified Terms will become effective immediately upon posting on this page. Your continued use of the Platform constitutes acceptance of the modified Terms. We recommend that you periodically review these Terms to stay informed of the latest content.`,
  },
  {
    title: "2. Platform Services",
    content: `2.1 Service Description
CCF Co-Creation Farm is an online dairy farming investment platform that connects premium global partner farms with farming members, providing dairy farming investment opportunities and corresponding returns distribution services.

2.2 Service Content
• Displaying and browsing partner farm information
• Supporting user account registration and joining farming programs
• Managing farming investments and returns distribution
• Providing farming progress tracking and returns detail inquiry
• Publishing farm updates and platform announcements

2.3 Service Changes
We reserve the right to modify, suspend, or terminate all or part of the services at any time without prior notice. We shall not be liable to you or any third party for any modification, suspension, or termination of the services.

2.4 Service Availability
We will use reasonable efforts to ensure continuous availability of the services, but we do not guarantee that the services will be uninterrupted or error-free. The Platform may be temporarily unavailable due to maintenance, upgrades, or other reasons.`,
  },
  {
    title: "3. Account Registration and Management",
    content: `3.1 Registration Eligibility
You must be at least 18 years of age and have full legal capacity to register an account. By registering, you represent and warrant that you meet the above eligibility requirements.

3.2 Registration Information
All information you provide during registration must be true, accurate, complete, and up-to-date. You are responsible for promptly updating your registration information to maintain its accuracy.

3.3 Account Security
You are solely responsible for maintaining the confidentiality of your account credentials (including username and password). You agree to:
• Not transfer, sell, or authorize any third party to use your account
• Immediately notify us if you discover any unauthorized use of your account
• Accept responsibility for all activities that occur under your account

3.4 Account Termination
We reserve the right to suspend or terminate your account at our sole discretion, including but not limited to the following circumstances:
• You have violated any provision of these Terms
• You have provided false, inaccurate, or incomplete registration information
• Your conduct may pose legal or financial risk to us or other users
• You have not used your account for an extended period`,
  },
  {
    title: "4. Farming Investment and Returns",
    content: `4.1 Investment Mechanism
Users select partner farms and join farming programs through the Platform. The specific terms of each farming program (including investment amount, farming cycle, expected return rate, etc.) will be clearly stated at the time of investment.

4.2 Returns Distribution
• The returns distribution ratio is 80% of the Platform's net profits allocated to farming members
• Returns are settled and distributed according to the agreed distribution cycle (e.g., monthly or quarterly)
• Actual returns may be affected by various factors including farm operational conditions and market conditions

4.3 Risk Disclosure
You fully understand and agree that:
• Dairy farming investments involve market risk, operational risk, and natural risk
• Historical returns do not represent future performance
• We do not guarantee any specific investment return
• Your investment decisions should be based on independent judgment and risk assessment
• We recommend that you consult an independent financial advisor before investing

4.4 Information Disclosure
We will regularly provide farming members with farm operational status reports and returns details. However, we do not make absolute guarantees regarding the completeness or accuracy of the information.`,
  },
  {
    title: "5. User Code of Conduct",
    content: `5.1 Lawful Use
You agree to use the Platform only for lawful purposes and to comply with all applicable laws and regulations. You shall not use the Platform to:

• Violate any applicable local, national, or international laws or regulations
• Infringe upon the intellectual property rights, privacy rights, or other legal rights of others
• Distribute malware, viruses, or other harmful code
• Interfere with or disrupt the normal operation of the Platform
• Engage in fraudulent, deceptive, or misleading activities
• Unauthorizedly access or use another user's account
• Collect or harvest personal information of other users
• Send spam or engage in unauthorized advertising

5.2 Content Posting
If you post or upload any content on the Platform (including comments, feedback, etc.), you grant us a worldwide, royalty-free, transferable license to use, reproduce, modify, adapt, publish, and display such content.

5.3 Violation Handling
If we discover that you have violated the above code of conduct, we have the right to:
• Remove violating content
• Suspend or terminate your account
• Report illegal activities to relevant law enforcement agencies
• Pursue legal liability against you`,
  },
  {
    title: "6. Intellectual Property",
    content: `6.1 Platform Intellectual Property
The Platform and all of its content (including but not limited to text, images, logos, software, design, audio, and video) are the exclusive property of CCF Co-Creation Farm or its licensors, protected by copyright, trademark, and other intellectual property laws.

6.2 Use Restrictions
Without our prior written consent, you shall not:
• Copy, modify, distribute, or otherwise use Platform content
• Use our trademarks, logos, or brand elements
• Decompile, reverse engineer, or attempt to obtain the Platform's source code
• Create derivative works based on the Platform

6.3 User Content
You retain ownership of content you post or upload on the Platform. However, you grant us a license to use such content on the Platform.`,
  },
  {
    title: "7. Third-Party Services",
    content: `7.1 Third-Party Links
The Platform may contain links to third-party websites or services. These third-party websites or services are not under our control, and we are not responsible for their content, privacy policies, or practices.

7.2 Third-Party Service Providers
We may use third-party service providers for payment processing, data analytics, cloud storage, and other services. Your use of these third-party services may be subject to their respective terms of service and privacy policies.

7.3 Partner Farms
The partner farms displayed on the Platform are independently operated third-party entities. We do not make guarantees regarding the operation, management, or financial condition of partner farms.`,
  },
  {
    title: "8. Limitation of Liability",
    content: `8.1 Disclaimer
To the maximum extent permitted by law, the Platform and its services are provided on an "as is" basis, without any express or implied warranties, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.

8.2 Limitation of Liability
To the maximum extent permitted by law, CCF Co-Creation Farm and its affiliates, officers, employees, and agents shall not be liable for any indirect, incidental, special, punitive, or consequential damages arising from the use of or inability to use the Platform, including but not limited to loss of profits, loss of data, or business interruption, whether based on contract, tort, or other legal theories.

8.3 Indemnification
You agree to indemnify and hold harmless CCF Co-Creation Farm and its affiliates, officers, employees, and agents from any claims, damages, losses, and expenses (including reasonable attorneys' fees) arising from your violation of these Terms or your use of the Platform.`,
  },
  {
    title: "9. Governing Law and Dispute Resolution",
    content: `9.1 Governing Law
These Terms shall be governed by and construed in accordance with the laws of the State of Colorado, United States, without regard to its conflict of law principles.

9.2 Dispute Resolution
Any dispute arising from these Terms or the use of the Platform shall first be resolved through friendly negotiation between the parties. If negotiation fails, either party may submit the dispute to a court of competent jurisdiction in the State of Colorado.

9.3 Statute of Limitations
You agree that any cause of action arising from these Terms must be filed within one year after the cause of action arises, or such cause of action shall be permanently barred.`,
  },
  {
    title: "10. General Provisions",
    content: `10.1 Entire Agreement
These Terms constitute the entire agreement between you and CCF Co-Creation Farm regarding the use of the Platform, superseding all prior oral or written communications, proposals, and representations.

10.2 Severability
If any provision of these Terms is held to be invalid or unenforceable, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions of these Terms shall continue in full force and effect.

10.3 Waiver
Our failure to exercise or enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.

10.4 Assignment
You may not assign any of your rights or obligations under these Terms without our prior written consent. We may freely assign our rights and obligations under these Terms.

10.5 Notices
We may send you notices via email, Platform announcements, or other reasonable means. You agree to receive all notices from us electronically.

10.6 Headings
The section headings in these Terms are for convenience only and shall not affect the interpretation of the Terms.`,
  },
  {
    title: "11. Contact Us",
    content: `If you have any questions or comments about these Terms of Service, or need to report any violations, please contact us through the following channels:

• Email: cocreationfarm@gmail.com
• Address: 5445 DTC Pkwy, Greenwood Village, CO 80111, United States
• Online Support: Contact us through the Platform's in-app customer support system

We will respond to your inquiry within a reasonable timeframe.`,
  },
];

export default function Terms() {
  return (
    <main className="w-full bg-background-50 text-foreground-950">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Terms of Service - Co-Creation Farm CCF",
        "description": "Terms of Service for CCF Co-Creation Farm, setting forth your rights and obligations when using our online dairy farming platform and related services.",
        "url": "%VITE_SITE_URL%/terms",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Co-Creation Farm",
          "url": "%VITE_SITE_URL%/"
        }
      }) }} />
      <Navbar />
      <div className="pt-20">
        <div className="w-full px-6 md:px-10 lg:px-14 py-16 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <p className="text-sm text-foreground-500 mb-3">Last Updated: June 15, 2020</p>
            <h1
              className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium tracking-tight"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Terms of Service
            </h1>
            <p className="mt-4 text-foreground-600 leading-relaxed max-w-2xl">
              Welcome to CCF Co-Creation Farm. These Terms of Service set forth your rights and obligations when using our platform and related services. By using the Platform, you agree to be bound by these Terms. Please read them carefully before use.
            </p>
          </div>
        </div>

        <div className="w-full px-6 md:px-10 lg:px-14 py-16 md:py-20">
          <div className="max-w-3xl mx-auto space-y-16">
            {SECTIONS.map((section) => (
              <section key={section.title}>
                <h2
                  className="text-xl md:text-2xl font-heading font-medium mb-5"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  {section.title}
                </h2>
                <div className="text-foreground-700 leading-relaxed text-sm md:text-base space-y-4 whitespace-pre-line">
                  {section.content}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}